import { Middleware } from "redux";
import {
  GET_USER_CRM_VALUES_SUCCESS,
  SET_CURRENT_USER_NAME_NUMBER,
  LOGOUT_SUCCESS,
} from "../actions/AccountActions";
import { AccountSessionStorage } from "../services/AccountSessionStorage";

export const accountContextPersistenceMiddleware: Middleware =
  (store) => (next) => (action) => {
    const result = next(action);

    switch (action.type) {
      case GET_USER_CRM_VALUES_SUCCESS:
      case SET_CURRENT_USER_NAME_NUMBER: {
        const state: any = store.getState();
        const {
          currentUserNameNumber,
          currentUserIpBaseNumber,
          currentViewAsUserName,
          currentUserGuid,
        } = state.account;

        AccountSessionStorage.save({
          currentUserNameNumber,
          currentUserIpBaseNumber,
          currentViewAsUserName,
          currentUserGuid,
        });
        break;
      }

      case LOGOUT_SUCCESS: {
        AccountSessionStorage.clear();
        break;
      }
    }

    return result;
  };
